import { Input } from '@commenda/kakashi';
import { getAvatarName } from '@commenda/utils';
import { themeColors } from '../../EquityInfo/common';

export const EquityAmountInput = ({
  idx,
  max,
  name,
  onChange,
  value,
  isDecimalEquityPercentageAllowed = true,
  disabled = false,
}: {
  idx: number;
  max: number;
  name: string;
  onChange: (e: any) => void;
  value: number;
  isDecimalEquityPercentageAllowed?: boolean;
  disabled?: boolean;
}) => {
  return (
    <div className="w-full flex items-center justify-between gap-4 grow shrink-0 pr-[80px]">
      <div className="flex items-center gap-2 w-full ">
        <span
          className="shrink-0 h-6 w-6 rounded flex items-center justify-center font-medium text-[10px]"
          style={{
            backgroundColor: `${themeColors[(idx + 1) % 6]}20`,
            color: themeColors[(idx + 1) % 6],
          }}
        >
          {getAvatarName(name)}
        </span>
        <span className="body-14-medium">{name}</span>
      </div>
      <div className="w-fit">
        <Input
          type="number"
          max={max}
          min={0}
          step={isDecimalEquityPercentageAllowed ? 0.01 : 1}
          className="w-28 hide-arrow"
          value={value}
          rightEl={() => <span className="translate-x-1">%</span>}
          onChange={(e) => {
            if (parseFloat(e.target.value) > 100) return;
            onChange(e);
          }}
          onWheel={(e) => e.currentTarget.blur()}
          readOnly={disabled}
        />
      </div>
    </div>
  );
};
